import React from 'react';
import { IconProps } from '.';

const SvgDiscountTagFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m23 12-5.5 8H1V4h16.5l5.5 8Zm-10.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-6.03 1.47 1.06 1.06 6-6-1.06-1.06-6 6ZM7.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDiscountTagFill;
